"use strict";

exports.__esModule = true;
exports.LoadingMediator = LoadingMediator;
var _react = _interopRequireWildcard(require("react"));
var _Spinner = require("../Spinner");
var _UhOh = require("../UhOh");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Mediates an async request, showing a spinner, error message or
 * invoking a render prop if the data is loaded.
 */
function LoadingMediator(_ref) {
  var loaded = _ref.loaded,
    fetching = _ref.fetching,
    data = _ref.data,
    error = _ref.error,
    interval = _ref.interval,
    intervalRoutine = _ref.intervalRoutine,
    reload = _ref.reload,
    children = _ref.children;
  var _useState = (0, _react.useState)(undefined),
    intervalID = _useState[0],
    setIntervalID = _useState[1];
  (0, _react.useEffect)(function () {
    return function () {
      clearInterval(intervalID);
    };
  }, [intervalID]);
  (0, _react.useEffect)(function () {
    setIntervalID(undefined);
    clearInterval(intervalID);
  }, [interval, intervalRoutine]);
  if (fetching) {
    return /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null);
  }
  if (!intervalID && interval > 0) {
    setIntervalID(function (oldIntervalID) {
      clearInterval(oldIntervalID);
      return setInterval(function () {
        intervalRoutine ? intervalRoutine() : reload();
      }, interval);
    });
  }
  if (error) {
    return /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
      error: error,
      onReload: reload
    });
  }
  if (loaded && data !== undefined) {
    return children(data);
  }
  return null;
}